/// <reference path="../../typings/index.d.ts" />